export enum VoucherEmailStatus {
  Delivered = 'delivered',
  Failed = 'failed',
  Pending = 'pending',
  Opened = 'opened',
  Clicked = 'clicked'
}
